import FinancialService from '@services/FinancialService';

import type { ReportFileProps } from './types';

export const handleDownloadReport = async ({
  reportsFile,
  personNumberFile,
}: ReportFileProps) => {
  if (!personNumberFile) return;
  const service = new FinancialService();

  await Promise.all(
    reportsFile.map(async report => {
      const path = await service.getCoparticipationReportDownload({
        personNumber: personNumberFile,
        billingExtractId: report.billingExtractId,
        fileName: report.fileName,
      });

      window.open(path, '_blank');
    }),
  );
};
